import React, { useState } from "react";
import PropTypes from "prop-types";
import { useIntl, defineMessages } from "react-intl";
import { connect } from "react-redux";
import Email from "@material-ui/icons/Email";
import SendIcon from "@material-ui/icons/Send";

import ModalExecutarAtividades from "../../atividades/Novo/components/ExecutarAtividades/ModalExecutarAtividades";
import { useUsuario } from "../../../hooks";
import { ActionButton } from "../../../components";
import { EnviarEmail } from "../../lead/components";

export const messages = defineMessages({
  sucessoCallbackEnvio: { defaultMessage: "Email(s) enviado(s) com sucesso" },
});

function EnviarEmailDashboardAtividade({ podeEnviarEmail, useJustIcon, atividade = {}, isDashboard, ...props }) {
  const intl = useIntl();
  const { isPVOrVendedor } = useUsuario();
  const [abrirExecutarAtividades, setAbrirExecutarAtividades] = useState(false);

  if (!atividade?.lead?.id) return null;
  const close = () => {
    setAbrirExecutarAtividades(false);
  };

  const openEmail = () => {
    if (isPVOrVendedor && !podeEnviarEmail) {
      props.history.push("/spotter/central-emails");
      return;
    }
    setAbrirExecutarAtividades(true);
  };

  return (
    <>
      {isDashboard ? (
        <>
          <ActionButton
            id="btn-enviar-email-atividade"
            type={useJustIcon ? "icon" : "menu"}
            onClick={openEmail}
            icon={useJustIcon ? <SendIcon /> : <Email />}
            label={!useJustIcon ? intl.formatMessage({ defaultMessage: "Enviar e-mail" }) : null}
            disabled={!podeEnviarEmail}
            {...props}
          />
          <ModalExecutarAtividades
            aberto={abrirExecutarAtividades}
            atividades={[atividade]}
            onClose={close}
            urlCallbackEnvio="/api/pipeline/atividade/ExecutaEmail"
            mensagemSucessoCallbackEnvio={messages.sucessoCallbackEnvio}
          />
        </>
      ) : (
        <EnviarEmail lead={atividade.lead} atividade={atividade} useIconMenu />
      )}
    </>
  );
}

EnviarEmailDashboardAtividade.propTypes = {
  children: PropTypes.func,
  podeEnviarEmail: PropTypes.bool,
  useJustIcon: PropTypes.bool,
  atividade: PropTypes.shape({
    nuTipoId: PropTypes.number.isRequired,
    status: PropTypes.number,
    lead: PropTypes.shape({
      id: PropTypes.number,
      nome: PropTypes.string,
      situacao: PropTypes.number,
      reuniao: PropTypes.shape({
        id: PropTypes.number,
        confirmacao: PropTypes.bool,
      }),
      contatos: PropTypes.arrayOf(
        PropTypes.shape({
          principal: PropTypes.bool,
          nome: PropTypes.string,
          cargo: PropTypes.string,
          email: PropTypes.string,
        })
      ).isRequired,
      contatosLead: PropTypes.arrayOf(
        PropTypes.shape({
          principal: PropTypes.bool,
          nome: PropTypes.string,
          cargo: PropTypes.string,
          email: PropTypes.string,
        })
      ).isRequired,
      etapa: PropTypes.shape({
        id: PropTypes.number.isRequired,
        permissoes: PropTypes.arrayOf(PropTypes.shape({ tipoPerfil: PropTypes.number, permissao: PropTypes.number })),
        proximaEtapaId: PropTypes.number,
        questionario: PropTypes.shape({ id: PropTypes.number, tipo: PropTypes.number }),
        tipoGate: PropTypes.number,
      }).isRequired,
    }),
  }),
  history: PropTypes.object,
  isDashboard: PropTypes.bool,
};

const mapStateToProps = state => ({
  podeEnviarEmail: state.emails && state.emails?.isAutenticado && !state.emails?.isAutenticacaoComFalha,
});

export default connect(mapStateToProps)(EnviarEmailDashboardAtividade);
